// Update SITE_URL once the app has a production domain. It drives canonical
// links and Open Graph/Twitter image URLs, which must be absolute.
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://remembr.arrayscript.com';

export const SITE_NAME = 'Remembr';

export const DEFAULT_TITLE = 'Remembr — Never Get Overcharged Twice';

export const DEFAULT_DESCRIPTION =
  "Remembr keeps a diary of every service and repair for your car, appliances, and anything else that wears out — the date, the cost, and what was done. Next time you're quoted a price, you'll know exactly what you paid last time.";

export const DEFAULT_IMAGE = '/hero.png';

export const COMPANY = {
  name: 'Arrayscript',
  url: 'https://www.arrayscript.com',
  email: 'support@arrayscript.com',
  sameAs: [
    'https://www.facebook.com/arrayscript',
    'https://x.com/arrayscript',
    'https://www.linkedin.com/company/arrayscript',
    'https://www.instagram.com/array.script',
  ],
};
